import styles from "./Header.module.scss";
import { Link } from "react-router-dom";
import { FaGithub, FaLinkedinIn, FaWhatsapp, FaTwitter } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import { BsMedium } from "react-icons/bs";
import { useLocation } from "react-router-dom";
import { useState } from "react";

const Header = () => {
  const [urlPath, setUrlPath] = useState("");
  const location = useLocation();
  const pathname = location.pathname;

  return (
    <header className={`sw ${styles.header}`}>
      <div className={styles.header_content}>
        <h1 className={styles.name}> Barnabas Oriyomi Olugbogi</h1>
        <span className={styles.domain}>React Developer & Data Analyst</span>
        <div className={styles.nav_div}>
          <nav className={styles.navlinks}>
            <Link
              to={"/about"}
              className={
                pathname === "/about"
                  ? styles.pathname_found
                  : styles.pathname_not_found
              }
            >
              About Me
            </Link>
            <Link
              to={"/projects"}
              className={
                pathname === "/projects"
                  ? styles.pathname_found
                  : styles.pathname_not_found
              }
            >
              React Projects
            </Link>
            <Link
              to={"/data-projects"}
              className={
                pathname === "/data-projects"
                  ? styles.pathname_found
                  : styles.pathname_not_found
              }
            >
              Data Projects
            </Link>
            <Link
              to={"/machine-learning"}
              className={
                pathname === "/machine-learning"
                  ? styles.pathname_found
                  : styles.pathname_not_found
              }
            >
              Machine Learning Projects
            </Link>
            <Link
              to={"/technical-stack"}
              className={
                pathname === "/technical-stack"
                  ? styles.pathname_found
                  : styles.pathname_not_found
              }
            >
              Technical Stack
            </Link>
          </nav>
        </div>
        <div className={styles.social_media}>
          <Link
            to={"mailto:barnascript@gmail.com"}
            target="_blank"
            className={styles.icon}
            arial-label="This links to an email incase you want to message me"
          >
            <HiOutlineMail />
          </Link>
          <Link
            to={"https://linkedin.com/in/barnascript"}
            target="_blank"
            className={styles.icon}
            arial-label="This links to a LinkedIn account"
          >
            <FaLinkedinIn />
          </Link>
          <Link
            to={"https://github.com/barnascript"}
            target="_blank"
            className={styles.icon}
            arial-label="This links to a Github account"
          >
            <FaGithub />
          </Link>
          <Link
            to={"https://twitter.com/barnascript"}
            target="_blank"
            className={styles.icon}
            arial-label="This links to a Twitter account"
          >
            <FaTwitter />
          </Link>
          <Link
            to="https://medium.com/@barnascript"
            target="_blank"
            className={styles.icon}
            arial-label="This links to a Medium account"
          >
            <BsMedium />
          </Link>
          <Link
            to="https://wa.link/w4nv7u"
            target="_blank"
            className={styles.icon}
            arial-label="This links to a Whatsapp number"
          >
            <FaWhatsapp />
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header;
